import { Trans } from '@lingui/react'
import {
  ButtonGroup,
  TextButton,
} from '@twistopayments/design-system/components/atoms/button'
import {
  Headline,
  HeadlineIcon,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twistopayments/design-system/components/atoms/headline'
import { BigContractWarningIcon } from '@twistopayments/design-system/icons/big'
import { styleUtils } from '@twistopayments/design-system/styles'
import { useRouter } from 'next/router'

import { useCancelFlow } from '@twisto/flow-views/components'

import * as styles from '../flow-leave-confirm-modal.styles'

type Props = {
  onClose: () => void
}

export const ConsentCollectionContent = ({ onClose }: Props) => {
  const router = useRouter()
  const sessionId = router.query.sessionId as string
  const cancelFlow = useCancelFlow(sessionId)

  return (
    <div css={styles.modalContent}>
      <Headline>
        <HeadlineIcon>
          <BigContractWarningIcon color="warning" height="100%" width="100%" />
        </HeadlineIcon>
        <HeadlineTitle>
          <Trans id="flow.leaveConfirmModal.consentCollection.title" />
        </HeadlineTitle>

        <HeadlineSubtitle>
          <Trans id="flow.leaveConfirmModal.consentCollection.subtitle.first" />
        </HeadlineSubtitle>
        <HeadlineSubtitle>
          <Trans id="flow.leaveConfirmModal.consentCollection.subtitle.second" />
        </HeadlineSubtitle>
      </Headline>
      <ButtonGroup css={styleUtils.margin.top.xl}>
        <TextButton fullWidth onClick={onClose}>
          <Trans id="flow.leaveConfirmModal.consentCollection.button.stay" />
        </TextButton>
        <TextButton fullWidth color="secondary" onClick={cancelFlow}>
          <Trans id="flow.leaveConfirmModal.consentCollection.button.leave" />
        </TextButton>
      </ButtonGroup>
    </div>
  )
}
